import React, { useState, useEffect } from 'react';
import styles from './SurveyableField.module.css';
import { get } from '../../utils/utils';
import { AdminCheckbox, AdminSelect } from '@project/components';
import { useIntl } from 'react-intl';

const classNames = require('classnames');


const SurveyableField = ({ form, isReadOnly, formKey, isSurveyed, updateField, saveForm, fieldKey: key, children }) => {
  const fieldName = key.split('.').pop() + '_not_surveyed';

  const notSurveyedValue = get(form, `${formKey}.${fieldName}`);

  // state for the not surveyed checkbox
  const [notSurveyed, setNotSurveyed] = useState(!!notSurveyedValue);

  // keeps the checkbox in sync when the reason is set externally (e.g. a toggleFor field toggling this one)
  useEffect(() => {
    setNotSurveyed(!!notSurveyedValue);
  }, [notSurveyedValue]);

  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const surveyOptions = [
    { value: 'Tenant Denied', label: t('SurveyableField.notSurveyedOption.tenantDenied') },
    { value: 'Lockbox Issues', label: t('SurveyableField.notSurveyedOption.lockboxIssues') }, //Lockbox w/No Access
    { value: 'Construction Onsite', label: t('SurveyableField.notSurveyedOption.construction') },
    { value: 'Physically Inaccessible', label: t('SurveyableField.notSurveyedOption.physicallyInaccessibleObstructions') },
    { value: 'No Access', label: t('SurveyableField.notSurveyedOption.noAccess') }, //Wall Inaccessible
    { value: 'Permanent Ceiling', label: t('SurveyableField.notSurveyedOption.permanentCeiling') },
    { value: 'Insulation', label: t('SurveyableField.notSurveyedOption.insulation') },
    { value: 'Asset Not Present', label: t('SurveyableField.notSurveyedOption.assetNotPresent') },
    { value: 'Ceiling Not Present', label: t('SurveyableField.notSurveyedOption.ceilingNotPresent') },
    { value: 'Joist Not Present', label: t('SurveyableField.notSurveyedOption.joistNotPresent') },
    { value: 'Deck Not Present', label: t('SurveyableField.notSurveyedOption.deckNotPresent') },
    { value: 'Girder Not Present', label: t('SurveyableField.notSurveyedOption.girderNotPresent') },
    { value: 'Column Not Present', label: t('SurveyableField.notSurveyedOption.columnNotPresent') },
    { value: 'Speed Bay Not Present', label: t('SurveyableField.notSurveyedOption.speedBayNotPresent') },
    { value: 'Truck Apron Not Present', label: t('SurveyableField.notSurveyedOption.truckApronNotPresent') },
    { value: 'Truck Court Not Present', label: t('SurveyableField.notSurveyedOption.truckCourtNotPresent') },
    { value: 'Not Present', label: t('SurveyableField.notSurveyedOption.notPresent') }, //WALL NOT PRESENT
    { value: 'Lockbox Not Present', label: t('SurveyableField.notSurveyedOption.lockboxNotPresent') },
    { value: 'Lockbox Jammed', label: t('SurveyableField.notSurveyedOption.lockboxJammed') },
    { value: 'Lockbox Wrong Key', label: t('SurveyableField.notSurveyedOption.lockboxWrongKey') },
    { value: 'Lockbox No Key', label: t('SurveyableField.notSurveyedOption.lockboxNoKey') },
    { value: 'Not Provided', label: t('SurveyableField.notSurveyedOption.notProvided') }, //RSF Not Provided
    { value: 'Not Part of Scope', label: t('SurveyableField.notSurveyedOption.notPartOfScope') },
    { value: 'Revisit Required', label: t('SurveyableField.notSurveyedOption.revisitRequired') },
    { value: 'Safety Concerns', label: t('SurveyableField.notSurveyedOption.safety') },
    { value: 'Poor Weather', label: t('SurveyableField.notSurveyedOption.weather') },
    { value: 'Equipment Issues', label: t('SurveyableField.notSurveyedOption.equipmentIssues') },
    { value: 'Emergency Reasons', label: t('SurveyableField.notSurveyedOption.emergencyReasons') }
    
  ];

  const saveNotSurveyedReason = e => {
    const formValue = { target: { type: 'select', value: e.value, checked: false } }
    updateField(fieldName, formValue, get(form, formKey), false, key)
    saveForm(true);
  }

  if (!fieldName) return null;

  // render just the wrapped component if the field is not surveyable
  if (!isSurveyed) return children;

  return (
    <>
      {children}
      <div>
        <AdminCheckbox
          id={`${key}_${fieldName}`}
          label={t('SurveyableField.notSurveyed')}
          checked={notSurveyed}
          readOnly={isReadOnly}
          removeMargins={true}
          justifyContent={false}
          onChange={e => {
            setNotSurveyed(e.target.checked);
            if (!e.target.checked) saveNotSurveyedReason({ value: '' });
          }}
          customLabelStyle={styles.notSurveyedCheckboxLabel}
          customstyle={styles.notSurveyedCheckbox}
        />
      </div>
      <div className={styles.notSurveyedInputs}>
        {
          notSurveyed ?
            <AdminSelect
              id={`${key}_${fieldName}_reason`}
              options={surveyOptions}
              label=""
              value={surveyOptions.filter(option => option.value === notSurveyedValue)}
              onChange={saveNotSurveyedReason}
              className={classNames(styles.notSurveyedSelect)}
              isDisabled={isReadOnly}
              placeholder={t('SurveyableField.notSurveyedReason')}
              data-testid="not-survey-reason"
              identifierClass={'data-not-survey-reason'} />
            : null
        }
      </div>
    </>
  )
}

export default SurveyableField;
